import { combineReducers } from 'redux';

import byPage from './byPage/reducer';
import byKeyMaker from 'reducersMakers/byKeyMaker';

export default byKeyMaker('commentsQueryString', combineReducers({ byPage }));



/** WEBPACK FOOTER **
 ** ./src/members/state/comments/byQuery/reducer.js
 **/